import { createContext, useContext } from 'react';

export const AdminToastContext = createContext(null);

export const useAdminToast = () => useContext(AdminToastContext);
